import Popup from "../modals/Popup";
import NotificationCart from "../NotificationCart";
import { userDateTimeJalali } from "../../utils/userDateTimeJalali";
import { useNavigate } from "react-router";
import Loading from "../common/Loading";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  data: dataProps[];
  redirect_route: string;
  isLoading: boolean;
};

type dataProps = {
  title: string;
  message: string;
  date: string;
  time: string;
  notification_type:
    | "NORMAL_NOTIFICATION"
    | "SUCCESS_NOTIFICATION"
    | "FAIL_NOTIFICATION";
  notification_uid: string;
  created_at: string;
  is_read: boolean;
};
//
export default function NotifBox(props: Props) {
  const navigate = useNavigate();
  return (
    <Popup
      noneSpace
      isOpen={props.isOpen}
      onClose={props.onClose}
      position="top-16 sm:left-0 -left-[70px]"
    >
      {props.isLoading ? (
        <div className="sm:w-[300px] w-[200px]">
          <Loading width={50} height={50} />
        </div>
      ) : (
        <div className="min-h-[100px] sm:w-[300px] w-[200px]">
          {props.data?.map((v: dataProps, i: number) => {
            return (
              <div key={i} className="w-full">
                <NotificationCart
                  onClickIcon={() => {
                    props.onClose();
                    navigate(props.redirect_route);
                  }}
                  {...v}
                  time={userDateTimeJalali(v.created_at)?.time}
                  date={userDateTimeJalali(v.created_at).date}
                />
                <hr className="bg-gray-200" />
              </div>
            );
          })}
          <div className="py-3 text-center">
            <p
              className="text-primary-600 text-BodyText/12/Regular cursor-pointer"
              onClick={() => {
                props.onClose();
                navigate(props.redirect_route);
              }}
            >
              مشاهده
            </p>
          </div>
        </div>
      )}
    </Popup>
  );
}
